function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.984253 11.4836C4.30676 5.7366 10.4679 1.93774 17.5 1.93774C22.7902 1.93774 27.5643 4.08069 31.0481 7.58732C32.2093 8.7562 33.2093 10.0549 34.0157 11.4836",
  stroke: "#434343",
  strokeWidth: 2,
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5 7.2951C24.2095 7.2951 29.6287 12.7823 29.6287 19.5034V26.8738C29.6287 28.2375 28.532 29.3739 27.1449 29.3739H7.85506C6.50025 29.3739 5.37125 28.27 5.37125 26.8738V19.5034C5.37125 12.7499 10.8227 7.2951 17.5 7.2951Z",
  fill: "white",
  stroke: "#434343",
  strokeWidth: 2,
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M6.14543 28.7245L3.85516 31.0623",
  stroke: "#434343",
  strokeWidth: 2,
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M28.8546 28.7245L31.1448 31.0623",
  stroke: "#434343",
  strokeWidth: 2,
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M26.6288 11.4511L28.9191 9.11334",
  stroke: "#434343",
  strokeWidth: 2,
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M8.40344 11.4511L6.11317 9.11334",
  stroke: "#434343",
  strokeWidth: 2,
  strokeLinejoin: "round"
});

var SvgChair = function SvgChair(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 32,
    viewBox: "0 0 35 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChair, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chair.77e02a68.svg";
export { ForwardRef as ReactComponent };